import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CallActionButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  testId?: string;
  variant: "destructive" | "success";
}

/** Large stacked icon + label, the accept/decline pair on both call screens. */
export function CallActionButton({
  label,
  icon,
  variant,
  onClick,
  testId,
}: CallActionButtonProps) {
  // We bypass the shadcn Button variants for the success case (not in the
  // default palette) and the round shape; use inline classes keyed off
  // tailwind tokens to keep dark-mode parity automatic.
  const bg =
    variant === "destructive"
      ? "bg-destructive text-destructive-foreground"
      : "bg-success text-success-foreground";

  return (
    <Button
      aria-label={label}
      className={cn(
        "flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-full shadow-lg",
        bg,
        "transition-transform hover:opacity-90 active:scale-95"
      )}
      data-testid={testId}
      onClick={onClick}
      type="button"
    >
      {icon}
      <span className="font-medium text-[10px] uppercase tracking-wide">
        {label}
      </span>
    </Button>
  );
}
